<template>
  <v-app>
    <v-app-bar app color="#231f20" dark>
      <v-layout justify-space-between fill-height align-center>
        <div class="logo-and-lang" style="display: flex; align-items: center;">
          <div @click="backToApp" style="cursor:pointer">
            <LogoLarge />
          </div>
          <LanguageDropdown class="ml-8" />
        </div>
        <h1 class="headline">{{ t('layouts.liveteamview.title') }}</h1>
        <UserMenu :user="user" :subtitle="user.companyName">
          <UserMenuItem icon="map_marker_alt" @click="backToApp">
            {{ t('layouts.training.backToMap') }}
          </UserMenuItem>
          <UserMenuItem v-if="isUserAdmin === true" icon="users" :to="{ name: 'admin' }">
            {{ t('layouts.training.admin') }}
          </UserMenuItem>
          <UserMenuItem v-if="isUserAdmin === true" icon="eye" :to="{ name: 'overwatch' }">
            {{ t('layouts.training.overwatch') }}
          </UserMenuItem>
          <UserMenuItem v-if="isUserAdmin === true" icon="viewer" :to="{ name: 'liveteam' }">
            {{ t('layouts.app.teamTrack') }}
          </UserMenuItem>
          <UserMenuItem icon="globe" href="https://i911help.zendesk.com/hc/en-us/sections/360009792793-FAQ" target="_blank">
            {{ t('layouts.training.contactSupport') }}
          </UserMenuItem>
          <UserMenuItem icon="sign_out" danger @click="signOut">
            {{ t('layouts.training.signOut') }}
          </UserMenuItem>
        </UserMenu>
      </v-layout>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'

// Must be high in the component hierarchy for correct DOM positioning.
import EndTrackingModal from '@/components/EndTrackingModal.vue'
import axios from "axios";
import {eventBus} from "@/main";
import LogoLarge from '@/components/LogoLarge.vue';

export default Vue.extend({
  data() {
    return {
      showErrorSnackbar: false,
      isHidden: false,
      seen: false
    }
  },
  methods: {
    t(key: string): string {
      return (this as any).$t(key)
    },
    backToApp() {
      this.$router.push({ name: 'dashboard' })
    },
    changeEmail() {
      store.commit('location/showEditEmailModal', true)
    },
    signOut() {
      store.dispatch('authentication/logout')
      store.dispatch('location/reset')
      // this.$tours.dashboardTour.stop()
      this.$router.push({
        name: 'auth-sign-in'
      })
    },
    toTraining() {
      this.$router.push({
        name: 'training'
      })
    },
    hideLocate() {
      this.isHidden = true
    },
  },
  computed: {
    phoneNumber: {
      get(): string {
        return store.state.location.phoneNumber
      },
      set(value: string) {
        store.commit('location/phoneNumber', value)
      }
    },
    isUserAdmin() {
      const user = store.state.authentication.currentUser
      return user && (user.isAdmin || user.isTeamAdmin || user.isAgencyAdmin)
    },
    smAndDown(): any {
      return this.$vuetify.breakpoint.smAndDown
    },
    user(): any {
      return store.state.authentication.currentUser
    },
  },
  components: {
    EndTrackingModal
  }
})
</script>
<style lang="scss" scoped>
.v-step {
  z-index: 100;
}

.headline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

v-list-item-title {
  background-color: transparent;
  font-weight: unset;
}

</style>
